var _path, _use, _path2, _use2, _use3, _use4, _use5, _use6, _use7, _use8, _use9, _use0, _use1, _use10, _use11, _use12, _use13, _use14, _use15, _use16, _use17, _use18, _use19, _use20, _use21, _use22, _use23, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPc = function SvgPc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#003da5",
    d: "M0 0h512v512H0z"
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#pc_svg__a",
    width: 1000,
    height: 700,
    transform: "rotate(164.3 247 258.3)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "pc_svg__a",
    fill: "#fff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 0.7,
    d: "m419 280.3-8.9 1.7-1.1 9-4.4-8-9 1.7 6.3-6.6-4.4-8 8.2 3.9 6.3-6.7-1.2 9z"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#pc_svg__a",
    width: 1000,
    height: 700,
    transform: "rotate(-10.3 247 258.3)"
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#pc_svg__a",
    width: 1000,
    height: 700,
    transform: "rotate(-30.9 247 258.3)"
  })), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#pc_svg__a",
    width: 1000,
    height: 700,
    transform: "rotate(-20.6 247 258.3)"
  })), _use5 || (_use5 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#pc_svg__a",
    width: 1000,
    height: 700,
    transform: "rotate(-51.5 247 258.3)"
  })), _use6 || (_use6 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#pc_svg__a",
    width: 1000,
    height: 700,
    transform: "rotate(-72.1 247 258.3)"
  })), _use7 || (_use7 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#pc_svg__a",
    width: 1000,
    height: 700,
    transform: "rotate(-61.8 247 258.3)"
  })), _use8 || (_use8 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#pc_svg__a",
    width: 1000,
    height: 700,
    transform: "rotate(-41.2 247 258.3)"
  })), _use9 || (_use9 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#pc_svg__a",
    width: 1000,
    height: 700,
    transform: "rotate(-92.7 247 258.3)"
  })), _use0 || (_use0 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#pc_svg__a",
    width: 1000,
    height: 700,
    transform: "rotate(-113.3 247 258.3)"
  })), _use1 || (_use1 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#pc_svg__a",
    width: 1000,
    height: 700,
    transform: "rotate(-103 247 258.3)"
  })), _use10 || (_use10 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#pc_svg__a",
    width: 1000,
    height: 700,
    transform: "rotate(-133.9 247 258.3)"
  })), _use11 || (_use11 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#pc_svg__a",
    width: 1000,
    height: 700,
    transform: "rotate(-154.5 247 258.3)"
  })), _use12 || (_use12 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#pc_svg__a",
    width: 1000,
    height: 700,
    transform: "rotate(-144.2 247 258.3)"
  })), _use13 || (_use13 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#pc_svg__a",
    width: 1000,
    height: 700,
    transform: "rotate(-123.6 247 258.3)"
  })), _use14 || (_use14 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#pc_svg__a",
    width: 1000,
    height: 700,
    transform: "rotate(-82.4 247 258.3)"
  })), _use15 || (_use15 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#pc_svg__a",
    width: 1000,
    height: 700,
    transform: "rotate(-175.1 247 258.3)"
  })), _use16 || (_use16 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#pc_svg__a",
    width: 1000,
    height: 700,
    transform: "rotate(174.6 247 258.3)"
  })), _use17 || (_use17 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#pc_svg__a",
    width: 1000,
    height: 700,
    transform: "rotate(143.7 247 258.3)"
  })), _use18 || (_use18 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#pc_svg__a",
    width: 1000,
    height: 700,
    transform: "rotate(123.1 247 258.3)"
  })), _use19 || (_use19 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#pc_svg__a",
    width: 1000,
    height: 700,
    transform: "rotate(133.4 247 258.3)"
  })), _use20 || (_use20 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#pc_svg__a",
    width: 1000,
    height: 700,
    transform: "rotate(154 247 258.3)"
  })), _use21 || (_use21 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#pc_svg__a",
    width: 1000,
    height: 700,
    transform: "rotate(-164.8 247 258.3)"
  })), _use22 || (_use22 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#pc_svg__a",
    width: 1000,
    height: 700,
    transform: "rotate(112.8 247 258.3)"
  })), _use23 || (_use23 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#pc_svg__a",
    width: 1000,
    height: 700,
    transform: "rotate(102.5 247 258.3)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#00aec7",
    strokeWidth: 14.6,
    d: "M389.2 334a161 161 0 0 1-161.9 84.2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M420.6 307.7s-26.9-12-81.3-12.2-112.2 14.8-144.1 14.4c-32-.4-41.4-.4-60.5-4 0 0 28.9 9.6 59.5 12.4s101.6-11.1 137-13.4c36.2-2.2 64.4-2.2 89.4 2.8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#00aec7",
    d: "M208 323.4s20.5 1 59.8-3.2 67.2-10 98.2-10.8 65.3 4.6 72.5 6.5c0 0-51.7-1.4-73.4 1.7s-77.8 10.1-107.4 10.8-39.7-3.3-49.7-5m-85.9-29.6s54.4 14.5 103.8 5c55.7-10.9 88.5-10.7 113.4-10.8s51 6.2 51 6.2S288 187.3 180.9 130.7c0 0-8 90.1-58.7 163"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M207.2 210.7s-1.5-5.7-9-4.9c0 0 4.8-2 7-1 2 1.2 2.5 1.5 2 5.9m-17.9-10s1.7-.6 2.3-.3c0 0 1.2 3.4 3.5 4.7 0 0-4-.3-5.8-4.5M213 206a13 13 0 0 0-9.3-5.1c-1.8 0-6.3 3.6-6.3 3.6-1.1-2-.6-3.6-.6-3.6 2.2.3 4 1 4 1a9 9 0 0 0-2.2-3.9c4.3-1.1 9.4 2.6 9.4 2.6a18 18 0 0 0-11.8-7.3c-1.2 0-2.8 1.8-2.8 1.8-8.3 0-10.5 4.6-10.5 4.6 3.4 5.4 10.6 6.7 10.6 6.7-12.6-1.4-12.3 8.4-12.3 8.4l11.6-6c-4.4 25.8-22.4 37.3-23.9 38.8-1.4 1.5-.5 3.1 1.7 3.3 1.1.2 2.6 1.1 6.6-3.5a70 70 0 0 0 17.5-37.8l.2.2c1.2 3 .4 5.8.6 7.8.3 2 4.7 6.3 4.7 6.3s2.4-4.7 2-7.5-5.8-8.1-5.8-8.1c8.4-1.5 8.9 12.4 8.9 12.4 3.2-3.8 2.5-7.8 2.5-7.8s6.7-4.9 5.2-6.9"
  })));
};
export default SvgPc;